import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import api, { getAll } from '../../services/api';
import authStore from '../../store/authStore';
import { puoModificare } from '../../utils/permessi';
import { notify } from '../../utils/notifications';
import {
  Plus, Search, Edit, Trash2, Bus, CheckCircle, XCircle, X,
  AlertTriangle, Calendar, Eye, Upload, FileText, Download
} from 'lucide-react';

const Pullman = () => {
  const { utente } = authStore();
  const modificabile = puoModificare(utente);
  const [pullman, setPullman] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filtroAttivo, setFiltroAttivo] = useState('TUTTI');
  const [showModal, setShowModal] = useState(false);
  const [showDettaglio, setShowDettaglio] = useState(null);
  const [editingPullman, setEditingPullman] = useState(null);
  const [filesDaCaricare, setFilesDaCaricare] = useState([]);
  const [uploadInCorso, setUploadInCorso] = useState(false);
  const [formData, setFormData] = useState({
    targa: '',
    modello: '',
    numero_interno: '',
    capienza: '',
    attivo: true,
    note: '',
    scadenza_estintore: '',
    scadenza_polizza: '',
    scadenza_revisione: '',
    scadenza_tachigrafo: '',
    scadenza_cassetta_medica: '',
    numero_autorizzazione: '',
    scadenza_autorizzazione: ''
  });

  useEffect(() => {
    caricaDati();
  }, []);

  const caricaDati = async () => {
    try {
      setLoading(true);
      setPullman(await getAll('/trasporti/mezzi/'));
    } catch (error) {
      console.error('Errore caricamento pullman:', error);
      notify.error('Errore nel caricamento dei pullman');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (mezzo = null) => {
    if (mezzo) {
      setEditingPullman(mezzo);
      setFormData({
        targa: mezzo.targa,
        modello: mezzo.modello,
        numero_interno: mezzo.numero_interno || '',
        capienza: mezzo.capienza,
        attivo: mezzo.attivo,
        note: mezzo.note || '',
        scadenza_estintore: mezzo.scadenza_estintore || '',
        scadenza_polizza: mezzo.scadenza_polizza || '',
        scadenza_revisione: mezzo.scadenza_revisione || '',
        scadenza_tachigrafo: mezzo.scadenza_tachigrafo || '',
        scadenza_cassetta_medica: mezzo.scadenza_cassetta_medica || '',
        numero_autorizzazione: mezzo.numero_autorizzazione || '',
        scadenza_autorizzazione: mezzo.scadenza_autorizzazione || ''
      });
    } else {
      setEditingPullman(null);
      setFormData({
        targa: '',
        modello: '',
        numero_interno: '',
        capienza: '',
        attivo: true,
        note: '',
        scadenza_estintore: '',
        scadenza_polizza: '',
        scadenza_revisione: '',
        scadenza_tachigrafo: '',
        scadenza_cassetta_medica: '',
        numero_autorizzazione: '',
        scadenza_autorizzazione: ''
      });
    }
    setFilesDaCaricare([]);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingPullman(null);
    setFilesDaCaricare([]);
  };

  const handleAggiungiFile = () => {
    setFilesDaCaricare([...filesDaCaricare, { nome: '', file: null }]);
  };

  const handleFileChange = (index, campo, valore) => {
    const nuovi = [...filesDaCaricare];
    nuovi[index][campo] = valore;
    setFilesDaCaricare(nuovi);
  };

  const handleRimuoviFile = (index) => {
    setFilesDaCaricare(filesDaCaricare.filter((_, i) => i !== index));
  };

  const caricaDocumenti = async (mezzoId) => {
    for (const doc of filesDaCaricare) {
      if (!doc.file || !doc.nome) continue;
      const fd = new FormData();
      fd.append('mezzo', mezzoId);
      fd.append('nome', doc.nome);
      fd.append('file', doc.file);
      await api.post('/trasporti/documenti-mezzi/', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const toastId = notify.loading(editingPullman ? 'Aggiornamento...' : 'Creazione...');

    const datiDaInviare = { ...formData };
    const campiData = ['scadenza_estintore', 'scadenza_polizza', 'scadenza_revisione', 'scadenza_tachigrafo', 'scadenza_cassetta_medica', 'scadenza_autorizzazione'];
    campiData.forEach(campo => {
      if (!datiDaInviare[campo]) datiDaInviare[campo] = null;
    });

    try {
      let mezzoId;
      if (editingPullman) {
        await api.put(`/trasporti/mezzi/${editingPullman.id}/`, datiDaInviare);
        mezzoId = editingPullman.id;
      } else {
        const res = await api.post('/trasporti/mezzi/', datiDaInviare);
        mezzoId = res.data.id;
      }

      if (filesDaCaricare.some(d => d.file && d.nome)) {
        setUploadInCorso(true);
        await caricaDocumenti(mezzoId);
        setUploadInCorso(false);
      }

      notify.update(toastId, { type: 'success', render: editingPullman ? 'Pullman aggiornato!' : 'Pullman creato!' });
      await caricaDati();
      handleCloseModal();
    } catch (error) {
      setUploadInCorso(false);
      console.error('Errore salvataggio pullman:', error);
      const errorMsg = error.response?.data?.targa?.[0] ||
                       error.response?.data?.detail ||
                       'Errore nel salvataggio';
      notify.update(toastId, { type: 'error', render: errorMsg });
    }
  };

  const handleEliminaDocumento = async (docId) => {
    if (!window.confirm('Eliminare questo documento?')) return;
    const toastId = notify.loading('Eliminazione...');
    try {
      await api.delete(`/trasporti/documenti-mezzi/${docId}/`);
      notify.update(toastId, { type: 'success', render: 'Documento eliminato!' });
      await caricaDati();
      if (showDettaglio) {
        const aggiornato = (await api.get(`/trasporti/mezzi/${showDettaglio.id}/`)).data;
        setShowDettaglio(aggiornato);
      }
    } catch (error) {
      notify.update(toastId, { type: 'error', render: 'Errore eliminazione documento' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo pullman?')) return;
    const toastId = notify.loading('Eliminazione...');
    try {
      await api.delete(`/trasporti/mezzi/${id}/`);
      notify.update(toastId, { type: 'success', render: 'Pullman eliminato con successo!' });
      await caricaDati();
    } catch (error) {
      console.error('Errore eliminazione pullman:', error);
      notify.update(toastId, { type: 'error', render: 'Errore nell\'eliminazione del pullman' });
    }
  };

  const handleToggleAttivo = async (id, currentStatus) => {
    const toastId = notify.loading(currentStatus ? 'Disattivazione...' : 'Attivazione...');
    try {
      await api.patch(`/trasporti/mezzi/${id}/`, { attivo: !currentStatus });
      notify.update(toastId, {
        type: 'success',
        render: currentStatus ? 'Pullman disattivato!' : 'Pullman attivato!'
      });
      await caricaDati();
    } catch (error) {
      console.error('Errore toggle attivo:', error);
      notify.update(toastId, { type: 'error', render: 'Errore nell\'operazione' });
    }
  };

  const handleApriDettaglio = async (mezzo) => {
    try {
      const res = await api.get(`/trasporti/mezzi/${mezzo.id}/`);
      setShowDettaglio(res.data);
    } catch (error) {
      setShowDettaglio(mezzo);
    }
  };

  const filteredPullman = pullman.filter(mezzo => {
    const matchSearch =
      mezzo.targa?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mezzo.modello?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mezzo.numero_interno?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchAttivo =
      filtroAttivo === 'TUTTI' ||
      (filtroAttivo === 'ATTIVI' && mezzo.attivo) ||
      (filtroAttivo === 'INATTIVI' && !mezzo.attivo);
    return matchSearch && matchAttivo;
  });

  const verificaScadenza = (data) => {
    if (!data) return null;
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const scadenza = new Date(data);
    const diffGiorni = Math.ceil((scadenza - oggi) / (1000 * 60 * 60 * 24));
    if (diffGiorni < 0) return 'scaduto';
    if (diffGiorni <= 30) return 'in_scadenza';
    return 'valido';
  };

  const formattaData = (data) => {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('it-IT');
  };

  const getBadgeScadenza = (data) => {
    const stato = verificaScadenza(data);
    if (!stato) return <span className="text-gray-400 text-xs">-</span>;
    const stili = {
      scaduto: 'bg-red-100 text-red-800',
      in_scadenza: 'bg-yellow-100 text-yellow-800',
      valido: 'bg-green-100 text-green-800'
    };
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full font-medium ${stili[stato]}`}>
        {(stato === 'scaduto' || stato === 'in_scadenza') && <AlertTriangle className="w-3 h-3" />}
        {formattaData(data)}
      </span>
    );
  };

  const contaScadenze = (mezzi) => {
    let scadute = 0;
    let inScadenza = 0;
    const campiScadenza = ['scadenza_estintore', 'scadenza_polizza', 'scadenza_revisione', 'scadenza_tachigrafo', 'scadenza_cassetta_medica', 'scadenza_autorizzazione'];
    mezzi.forEach(m => {
      campiScadenza.forEach(campo => {
        const stato = verificaScadenza(m[campo]);
        if (stato === 'scaduto') scadute++;
        if (stato === 'in_scadenza') inScadenza++;
      });
    });
    return { scadute, inScadenza };
  };

  const scadenzeStats = contaScadenze(pullman.filter(p => p.attivo));

  const stats = {
    totale: pullman.length,
    attivi: pullman.filter(p => p.attivo).length,
    inattivi: pullman.filter(p => !p.attivo).length,
    postiTotali: pullman.filter(p => p.attivo).reduce((sum, p) => sum + (p.capienza || 0), 0)
  };

  // L'indirizzo lo fornisce l'API, firmato e a scadenza: i documenti non
  // stanno più sotto /media in chiaro, quindi qui non si costruisce nulla.
  const getFileUrl = (filePath) => filePath || '';

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="p-4 sm:p-6">
        {/* Header */}
        <div className="flex flex-wrap justify-between items-center gap-3 mb-5">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Pullman</h1>
            <p className="text-sm text-gray-500 mt-0.5">Gestisci la flotta di pullman</p>
          </div>
          {modificabile && (
          <button
            onClick={() => handleOpenModal()}
            className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#1b94ce] to-[#157bb0] rounded-lg text-white hover:opacity-90 transition shadow-sm font-semibold"
          >
            <Plus className="w-4 h-4" />
            Nuovo Pullman
          </button>
          )}
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-sm">Totale Pullman</p>
              <Bus className="w-4 h-4 text-gray-400" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{stats.totale}</p>
            <p className="text-gray-400 text-xs mt-1">nella flotta</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-sm">Attivi</p>
              <CheckCircle className="w-4 h-4 text-green-500" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{stats.attivi}</p>
            <p className="text-gray-400 text-xs mt-1">operativi</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-sm">Inattivi</p>
              <XCircle className="w-4 h-4 text-red-500" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{stats.inattivi}</p>
            <p className="text-gray-400 text-xs mt-1">non operativi</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-sm">Posti Totali</p>
              <Bus className="w-4 h-4 text-blue-500" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{stats.postiTotali}</p>
            <p className="text-gray-400 text-xs mt-1">capacità flotta attiva</p>
          </div>

          {(scadenzeStats.scadute > 0 || scadenzeStats.inScadenza > 0) && (
            <div className={`border rounded-lg p-6 shadow-sm ${scadenzeStats.scadute > 0 ? 'bg-red-50 border-red-200' : 'bg-yellow-50 border-yellow-200'}`}>
              <div className="flex items-center justify-between mb-2">
                <p className={`text-sm ${scadenzeStats.scadute > 0 ? 'text-red-600' : 'text-yellow-600'}`}>Scadenze</p>
                <AlertTriangle className={`w-4 h-4 ${scadenzeStats.scadute > 0 ? 'text-red-500' : 'text-yellow-500'}`} />
              </div>
              {scadenzeStats.scadute > 0 && (
                <p className="text-lg font-bold text-red-700">{scadenzeStats.scadute} scadut{scadenzeStats.scadute === 1 ? 'a' : 'e'}</p>
              )}
              {scadenzeStats.inScadenza > 0 && (
                <p className={`text-sm font-semibold ${scadenzeStats.scadute > 0 ? 'text-red-600' : 'text-yellow-700 text-lg'}`}>
                  {scadenzeStats.inScadenza} in scadenza (30gg)
                </p>
              )}
            </div>
          )}
        </div>

        {/* Filtri */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-5">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Cerca per targa, modello o numero interno..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <select
              value={filtroAttivo}
              onChange={(e) => setFiltroAttivo(e.target.value)}
              className="px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="TUTTI">Tutti</option>
              <option value="ATTIVI">Solo Attivi</option>
              <option value="INATTIVI">Solo Inattivi</option>
            </select>
          </div>
        </div>

        {/* Tabella Pullman */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {filteredPullman.length === 0 ? (
            <div className="p-12 text-center">
              <div className="w-24 h-24 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                <Bus className="w-12 h-12 text-gray-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Nessun pullman trovato</h3>
              <p className="text-gray-600 mb-5">
                {searchTerm || filtroAttivo !== 'TUTTI'
                  ? 'Prova con termini di ricerca diversi'
                  : 'Inizia aggiungendo il primo pullman alla flotta'}
              </p>
              {!searchTerm && filtroAttivo === 'TUTTI' && (
                <button
                  onClick={() => handleOpenModal()}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#1b94ce] to-[#157bb0] rounded-lg text-white hover:opacity-90 transition"
                >
                  <Plus className="w-4 h-4" />
                  Aggiungi Pullman
                </button>
              )}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Targa</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Modello</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Posti</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estintore</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Polizza</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Revisione</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tachigrafo</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cassetta Med.</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Autorizzazione</th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stato</th>
                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Azioni</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredPullman.map((mezzo) => (
                    <tr key={mezzo.id} className="hover:bg-gray-50 transition">
                      <td className="px-4 py-3 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${mezzo.attivo ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-400'}`}>
                            <Bus className="w-4 h-4" />
                          </div>
                          <div>
                            <div className="text-sm font-semibold text-gray-900">{mezzo.targa}</div>
                            {mezzo.numero_interno && <div className="text-xs text-gray-400">N. {mezzo.numero_interno}</div>}
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{mezzo.modello}</td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-gray-900">{mezzo.capienza}</td>
                      <td className="px-4 py-3 whitespace-nowrap">{getBadgeScadenza(mezzo.scadenza_estintore)}</td>
                      <td className="px-4 py-3 whitespace-nowrap">{getBadgeScadenza(mezzo.scadenza_polizza)}</td>
                      <td className="px-4 py-3 whitespace-nowrap">{getBadgeScadenza(mezzo.scadenza_revisione)}</td>
                      <td className="px-4 py-3 whitespace-nowrap">{getBadgeScadenza(mezzo.scadenza_tachigrafo)}</td>
                      <td className="px-4 py-3 whitespace-nowrap">{getBadgeScadenza(mezzo.scadenza_cassetta_medica)}</td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <div>
                          {getBadgeScadenza(mezzo.scadenza_autorizzazione)}
                          {mezzo.numero_autorizzazione && <div className="text-xs text-gray-400 mt-0.5">N. {mezzo.numero_autorizzazione}</div>}
                        </div>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <button
                          onClick={() => handleToggleAttivo(mezzo.id, mezzo.attivo)}
                          className={`inline-flex items-center gap-1 px-3 py-1 text-xs rounded-full font-semibold transition ${mezzo.attivo ? 'bg-green-100 text-green-800 hover:bg-green-200' : 'bg-red-100 text-red-800 hover:bg-red-200'}`}
                        >
                          {mezzo.attivo ? <><CheckCircle className="w-3 h-3" /> Attivo</> : <><XCircle className="w-3 h-3" /> Inattivo</>}
                        </button>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium">
                        <div className="flex items-center justify-end gap-1">
                          <button
                            onClick={() => handleApriDettaglio(mezzo)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition"
                            title="Visualizza"
                          >
                            <Eye className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleOpenModal(mezzo)}
                            className="p-2 text-orange-600 hover:bg-orange-50 rounded-lg transition"
                            title="Modifica"
                          >
                            <Edit className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDelete(mezzo.id)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition"
                            title="Elimina"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {filteredPullman.length > 0 && (
          <div className="mt-4 text-sm text-gray-600 text-center">
            Totale: {filteredPullman.length} pullman
          </div>
        )}
      </div>

      {/* ===================== MODALE DETTAGLIO ===================== */}
      {showDettaglio && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center z-10">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${showDettaglio.attivo ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-400'}`}>
                  <Bus className="w-5 h-5" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-900">{showDettaglio.targa}</h2>
                  <p className="text-sm text-gray-500">{showDettaglio.modello}</p>
                </div>
              </div>
              <button onClick={() => setShowDettaglio(null)} className="p-2 hover:bg-gray-100 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="p-6 space-y-6">
              {/* Info generali */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500 mb-1">Targa</p>
                  <p className="font-bold text-gray-900">{showDettaglio.targa}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500 mb-1">Modello</p>
                  <p className="font-bold text-gray-900">{showDettaglio.modello}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500 mb-1">N. Interno</p>
                  <p className="font-bold text-gray-900">{showDettaglio.numero_interno || '-'}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500 mb-1">Capienza</p>
                  <p className="font-bold text-gray-900">{showDettaglio.capienza} posti</p>
                </div>
              </div>

              {/* Scadenze */}
              <div>
                <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-blue-500" />
                  Scadenze Documenti
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {[
                    { label: 'Estintore', campo: 'scadenza_estintore' },
                    { label: 'Polizza', campo: 'scadenza_polizza' },
                    { label: 'Revisione', campo: 'scadenza_revisione' },
                    { label: 'Tachigrafo', campo: 'scadenza_tachigrafo' },
                    { label: 'Cassetta Medica', campo: 'scadenza_cassetta_medica' },
                    { label: 'Autorizzazione', campo: 'scadenza_autorizzazione' },
                  ].map(({ label, campo }) => (
                    <div key={campo} className="border border-gray-200 rounded-lg p-3">
                      <p className="text-xs text-gray-500 mb-1">{label}</p>
                      <div>{getBadgeScadenza(showDettaglio[campo])}</div>
                    </div>
                  ))}
                </div>
                {showDettaglio.numero_autorizzazione && (
                  <div className="mt-2 text-sm text-gray-600">
                    Numero autorizzazione: <span className="font-semibold">{showDettaglio.numero_autorizzazione}</span>
                  </div>
                )}
              </div>

              {/* Documenti */}
              <div>
                <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
                  <FileText className="w-4 h-4 text-blue-500" />
                  Documenti Allegati ({showDettaglio.documenti?.length || 0})
                </h3>
                {(!showDettaglio.documenti || showDettaglio.documenti.length === 0) ? (
                  <p className="text-sm text-gray-400 text-center py-4">Nessun documento caricato</p>
                ) : (
                  <div className="space-y-2">
                    {showDettaglio.documenti.map((doc) => (
                      <div key={doc.id} className="flex items-center justify-between border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                            <FileText className="w-4 h-4 text-blue-500" />
                          </div>
                          <div>
                            <p className="text-sm font-semibold text-gray-900">{doc.nome}</p>
                            <p className="text-xs text-gray-400">
                              {new Date(doc.data_caricamento).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <a
                            href={getFileUrl(doc.file)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition"
                            title="Scarica"
                          >
                            <Download className="w-4 h-4" />
                          </a>
                          <button
                            onClick={() => handleEliminaDocumento(doc.id)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition"
                            title="Elimina"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {showDettaglio.note && (
                <div>
                  <h3 className="text-sm font-bold text-gray-800 mb-2">Note</h3>
                  <p className="text-sm text-gray-600 bg-gray-50 rounded-lg p-3">{showDettaglio.note}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ===================== MODALE CREAZIONE/MODIFICA ===================== */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex justify-between items-center z-10">
              <h2 className="text-2xl font-bold text-gray-900">
                {editingPullman ? 'Modifica Pullman' : 'Nuovo Pullman'}
              </h2>
              <button onClick={handleCloseModal} className="p-2 hover:bg-gray-100 rounded-lg transition">
                <X className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Targa *</label>
                  <input
                    type="text"
                    required
                    value={formData.targa}
                    onChange={(e) => setFormData({ ...formData, targa: e.target.value.toUpperCase() })}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent uppercase"
                    placeholder="AA123BB"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Numero Interno</label>
                  <input
                    type="text"
                    value={formData.numero_interno}
                    onChange={(e) => setFormData({ ...formData, numero_interno: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="001"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Modello *</label>
                <input
                  type="text"
                  required
                  value={formData.modello}
                  onChange={(e) => setFormData({ ...formData, modello: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Mercedes Tourismo"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Capienza (Posti) *</label>
                <input
                  type="number"
                  required
                  min="1"
                  value={formData.capienza}
                  onChange={(e) => setFormData({ ...formData, capienza: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="50"
                />
              </div>

              {/* Scadenze */}
              <div className="border-t border-gray-200 pt-4">
                <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-blue-500" />
                  Scadenze Documenti
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { label: 'Scad. Estintore', campo: 'scadenza_estintore' },
                    { label: 'Scad. Polizza', campo: 'scadenza_polizza' },
                    { label: 'Scad. Revisione', campo: 'scadenza_revisione' },
                    { label: 'Scad. Tachigrafo', campo: 'scadenza_tachigrafo' },
                    { label: 'Scad. Cassetta Medica', campo: 'scadenza_cassetta_medica' },
                  ].map(({ label, campo }) => (
                    <div key={campo}>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">{label}</label>
                      <input
                        type="date"
                        value={formData[campo]}
                        onChange={(e) => setFormData({ ...formData, [campo]: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Autorizzazione */}
              <div className="border-t border-gray-200 pt-4">
                <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-blue-500" />
                  Autorizzazione
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Numero Autorizzazione</label>
                    <input
                      type="text"
                      value={formData.numero_autorizzazione}
                      onChange={(e) => setFormData({ ...formData, numero_autorizzazione: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Es. 12345"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Scad. Autorizzazione</label>
                    <input
                      type="date"
                      value={formData.scadenza_autorizzazione}
                      onChange={(e) => setFormData({ ...formData, scadenza_autorizzazione: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              {/* Upload Documenti */}
              <div className="border-t border-gray-200 pt-4">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-sm font-bold text-gray-800 flex items-center gap-2">
                    <Upload className="w-4 h-4 text-blue-500" />
                    Carica Documenti
                  </h3>
                  <button
                    type="button"
                    onClick={handleAggiungiFile}
                    className="text-xs flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition font-semibold"
                  >
                    <Plus className="w-3 h-3" />
                    Aggiungi file
                  </button>
                </div>

                {/* Documenti già caricati (solo in modifica) */}
                {editingPullman && editingPullman.documenti && editingPullman.documenti.length > 0 && (
                  <div className="mb-3 space-y-2">
                    <p className="text-xs text-gray-500 font-semibold">Documenti esistenti:</p>
                    {editingPullman.documenti.map((doc) => (
                      <div key={doc.id} className="flex items-center justify-between bg-gray-50 rounded-lg p-2 text-sm">
                        <div className="flex items-center gap-2">
                          <FileText className="w-4 h-4 text-gray-400" />
                          <span className="font-medium text-gray-700">{doc.nome}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <a
                            href={getFileUrl(doc.file)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-1 text-blue-600 hover:bg-blue-100 rounded transition"
                          >
                            <Download className="w-3.5 h-3.5" />
                          </a>
                          <button
                            type="button"
                            onClick={() => handleEliminaDocumento(doc.id)}
                            className="p-1 text-red-600 hover:bg-red-100 rounded transition"
                          >
                            <Trash2 className="w-3.5 h-3.5" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {filesDaCaricare.length === 0 ? (
                  <p className="text-xs text-gray-400 text-center py-3">Nessun nuovo file da caricare</p>
                ) : (
                  <div className="space-y-3">
                    {filesDaCaricare.map((item, index) => (
                      <div key={index} className="flex items-start gap-3 bg-blue-50 rounded-lg p-3">
                        <div className="flex-1 space-y-2">
                          <input
                            type="text"
                            placeholder="Nome documento (es. Polizza RCA 2026)"
                            value={item.nome}
                            onChange={(e) => handleFileChange(index, 'nome', e.target.value)}
                            className="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          />
                          <input
                            type="file"
                            onChange={(e) => handleFileChange(index, 'file', e.target.files[0])}
                            className="w-full text-sm text-gray-600 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => handleRimuoviFile(index)}
                          className="p-1.5 text-red-500 hover:bg-red-100 rounded-lg transition mt-1"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="attivo"
                  checked={formData.attivo}
                  onChange={(e) => setFormData({ ...formData, attivo: e.target.checked })}
                  className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                />
                <label htmlFor="attivo" className="text-sm font-semibold text-gray-700 cursor-pointer">
                  Pullman attivo e disponibile
                </label>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Note</label>
                <textarea
                  value={formData.note}
                  onChange={(e) => setFormData({ ...formData, note: e.target.value })}
                  rows={3}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Note aggiuntive sul pullman..."
                />
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-semibold"
                >
                  Annulla
                </button>
                <button
                  type="submit"
                  disabled={uploadInCorso}
                  className="px-6 py-2 bg-gradient-to-r from-[#1b94ce] to-[#157bb0] rounded-lg text-white hover:opacity-90 transition font-semibold disabled:opacity-50"
                >
                  {uploadInCorso ? 'Caricamento...' : editingPullman ? 'Salva Modifiche' : 'Crea Pullman'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default Pullman;
